// eslint-disable-next-line no-unused-vars
import config from '@config';
import './vendor/matter.js'; import './vendor/p5.js'; import './vendor/p5.sound.js'; import './vendor/pathseg.js';
import '@styles/frontend';
import '@images/favicon.ico';
import './spritesvg';
import './theme_functions';
